import { Injectable } from "@angular/core";
import { ApiNameList } from "src/environments/api-name-list";
import { HttpClientService } from "./http-client-service";


@Injectable()
export class SharedService {
   baseUrl = '';
    constructor(private httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

   
    universityLandingAPI() {
        return this.httpClientService.get(this.baseUrl + ApiNameList.restApi.universityLandingAPI);
    }

}
